export default {
  findByPath: function(obj: any, path: string): any {
    if (path === undefined || path === null) {
      return undefined;
    }
    try {
      let current: any = obj;
      // Support array index syntax, e.g., febs[0].field
      const hasArraySyntax = /\[\d+\]/.test(path);
      if (!hasArraySyntax) {
        path.split('.').forEach((p) => {
          if (current == null) return;
          current = current[p];
        });
        return current;
      }
      const segments = path
        .replace(/\]/g, '')
        .split('.')
        .map((seg) => seg.split('['))
        .flat();
      for (const seg of segments) {
        if (seg === '') continue;
        if (/^\d+$/.test(seg)) {
          const idx = parseInt(seg, 10);
          current = Array.isArray(current) ? current[idx] : undefined;
        } else {
          current = current ? current[seg] : undefined;
        }
        if (current === undefined || current === null) break;
      }
      return current;
    } catch {
      return undefined;
    }
  },
  setByPath: function(obj: any, path: string, value: any) {
    let i;
    let splittedPath = path.split(".");
    for (i = 0; i < splittedPath.length - 1; i++) {
      if (!obj[splittedPath[i]]) {
        obj[splittedPath[i]] = {};
      }
      obj = obj[splittedPath[i]];
    }
    obj[splittedPath[i]] = value;
  },
};
